import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { publishPlace } from '../../api/place.ts';

export default function usePublishPlace(): UseMutationResult<
  Awaited<ReturnType<typeof publishPlace>>,
  Error
> {
  return useMutation({
    mutationFn: publishPlace,
  });
}
